<template>
  <div>
    <div class="categories">
      <flickity ref="flickity" :options="flickityOptions">
        <div class="chip-container" @click="chipsSelected = []" role="row">
          <div class="mdc-chip" :class="{'active' : chipsSelected.length === 0}">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
              <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text">Todas las noticias</span>
              </span>
            </span>
          </div>
        </div>
        <div
          v-for="category in categories"
          :key="category.id"
          @click="toggleChip(category)"
          class="chip-container"
          role="row"
        >
          <div class="mdc-chip" :class="{'active' : isChipSelected(category)}">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
              <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text">{{category.name}}</span>
              </span>
            </span>
          </div>
        </div>
      </flickity>
    </div>
    <div v-if="loading" class="loading-container">
      <clip-loader color="#008a94"></clip-loader>
    </div>
    <transition-group v-else name="list" tag="div" class="d-flex flex-wrap" appear>
      <a :href="featuredBlog.link_blog" class="featured-blog" :key="0">
        <div class="image">

          <img alt="mainImage" :src="featuredBlog.main_image" class="featured-image">
        </div>
        <div class="info">
          <div class="info__content">
            <div class="flex justify-between items-center mb-4">
              <span class="chipped">{{featuredBlog.category_name}}</span>
              <!-- <span class="date">
                <i class="material-icons mdc-button__icon mr-2" aria-hidden="true">history</i>
                {{featuredBlog.format_date}}
              </span> -->
            </div>
            <h2>{{featuredBlog.title}}</h2>
            <p>{{featuredBlog.shortDescription}}</p>
          </div>
        </div>
      </a>
      <a
        :href="blog.link_blog"
        v-for="(blog, index) in blogsFiltered"
        :key="blog.id"
        class="blog-card"
        :class="{'first' : index == 0}"
      >
        <img alt="image" :src="blog.main_image" class="blog-image" />
        <div class="flex justify-between items-center mb-4 mt-5">
          <span class="chipped">{{blog.category_name}}</span>
          <!-- <span class="date">
            <i class="material-icons mdc-button__icon mr-2" aria-hidden="true">history</i>
            {{blog.format_date}}
          </span> -->
        </div>
        <h2 class="lg:mt-4">{{blog.title}}</h2>
        <p>{{blog.shortDescription}}</p>
      </a>
    </transition-group>
  </div>
</template>

<script>
import { MDCChipSet } from "@material/chips";
import Flickity from "vue-flickity";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  props: ["categories"],
  components: {
    Flickity,
    ClipLoader
  },
  data: () => ({
    flickityOptions: {
      initialIndex: 0,
      cellAlign: "left",
      prevNextButtons: true,
      contain: true,
      pageDots: false,
      wrapAround: false
    },
    chipsSelected: [],
    loading: true
  }),
  computed: {
    blogs() {
      let blogs = this.categories.flatMap(category => category.blogs);
      blogs.sort(function(a,b){
        return new Date(b.created_at) - new Date(a.created_at);
      });
      return blogs;
    },
    blogsFiltered() {
      const blogsFiltered =
        this.chipsSelected.length === 0
          ? this.blogs
          : this.chipsSelected.flatMap(chip => chip.blogs);

      return blogsFiltered;
    },
    featuredBlog() {
      return this.blogsFiltered[0];
    },
    blogList() {
      const [, ...rest] = this.blogsFiltered;
      return rest;
    }
  },
  methods: {
    _extraIndex(chip) {
      return this.chipsSelected.findIndex(e => e.id == chip.id);
    },
    isChipSelected(chip) {
      return this._extraIndex(chip) !== -1;
    },
    toggleChip(chip) {
      this.isChipSelected(chip)
        ? this.deactivateChip(chip)
        : this.activateChip(chip);
    },
    activateChip(chip) {
      this.chipsSelected = [...this.chipsSelected, chip];
    },
    deactivateChip(chip) {
      this.chipsSelected = this.chipsSelected.filter(c => c.id !== chip.id);
    }
  },
  mounted() {
    //Chips
    const chipsSelector = ".mdc-chip-set";
    const chips = [].map.call(
      document.querySelectorAll(chipsSelector),
      function(el) {
        return new MDCChipSet(el);
      }
    );

    window.setTimeout(() => {
      this.loading = false;
    }, 1500);
  }
};
</script>

<style lang="scss">
@import "../../sass/variables";

.categories {
  .flickity-viewport {
    @media(min-width: 1024px){
      margin: 0 50px;
    }
  }
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.v-spinner {
  .v-clip {
    border-width: 3px !important;
    animation: v-myClipDelay 1s 0s infinite linear;
  }
}

@keyframes v-myClipDelay {
  100% {
    -webkit-transform: rotate(360deg) scale(1);
    transform: rotate(360deg) scale(1);
  }
}
</style>
